package io.horion.cv.utils

import io.horion.cv.models.ApplyJob
import io.horion.cv.models.ApplyJobStatus

object ApplyJobTestData {

    // Candidatures en attente
    val pendingApplications = listOf(
        ApplyJob(
            id = "app_001",
            job = "1", // Développeur Senior
            user = "user_001", // Jean Dupont
            cv = "cv_jean_dupont.pdf",
            letter =null,
            status = ApplyJobStatus.PENDING,
            createdAt = "2026-03-25T10:30:00",
            updatedAt = "2026-03-25T10:30:00"
        ),
        ApplyJob(
            id = "app_002",
            job = "1", // Développeur Senior
            user = "user_003", // Marie Martin
            cv = "cv_marie_martin.pdf",
            letter = null,
            status = ApplyJobStatus.PENDING,
            createdAt = "2026-03-26T14:15:00",
            updatedAt = "2026-03-26T14:15:00"
        ),
        ApplyJob(
            id = "app_003",
            job = "2", // Data Scientist
            user = "user_002", // Sophie Bernard
            cv = "cv_sophie_bernard.pdf",
            letter = null,
            status = ApplyJobStatus.PENDING,
            createdAt = "2026-03-27T09:45:00",
            updatedAt = "2026-03-27T09:45:00"
        )
    )

    // Candidatures acceptées
    val acceptedApplications = listOf(
        ApplyJob(
            id = "app_004",
            job = "3", // Chef de Projet
            user = "user_004", // Thomas Petit
            cv = "cv_thomas_petit.pdf",
            letter =null,
            status = ApplyJobStatus.ACCEPTED,
            createdAt = "2026-03-20T11:00:00",
            updatedAt = "2026-03-28T16:20:00"
        ),
        ApplyJob(
            id = "app_005",
            job = "4", // UI/UX Designer
            user = "user_005", // Julie Moreau
            cv = "cv_julie_moreau.pdf",
            letter = null,
            status = ApplyJobStatus.ACCEPTED,
            createdAt = "2026-03-22T15:30:00",
            updatedAt = "2026-03-29T10:15:00"
        ),
        ApplyJob(
            id = "app_006",
            job = "1", // Développeur Senior
            user = "user_006", // Lucas Dubois
            cv = "cv_lucas_dubois.pdf",
            letter =null,
            status = ApplyJobStatus.ACCEPTED,
            createdAt = "2026-03-18T13:45:00",
            updatedAt = "2026-03-27T09:30:00"
        )
    )

    // Candidatures rejetées
    val rejectedApplications = listOf(
        ApplyJob(
            id = "app_007",
            job = "2", // Data Scientist
            user = "user_007", // Emma Blanc
            cv = "cv_emma_blanc.pdf",
            letter = null,
            status = ApplyJobStatus.REJECTED,
            createdAt = "2026-03-21T12:00:00",
            updatedAt = "2026-03-30T14:45:00"
        ),
        ApplyJob(
            id = "app_008",
            job = "3", // Chef de Projet
            user = "user_008", // Nicolas Leroy
            cv = "cv_nicolas_leroy.pdf",
            letter = null,
            status = ApplyJobStatus.REJECTED,
            createdAt = "2026-03-23T16:20:00",
            updatedAt = "2026-03-31T11:30:00"
        ),
        ApplyJob(
            id = "app_009",
            job = "5", // DevOps Engineer
            user = "user_009", // Camille Rousseau
            cv = "cv_camille_rousseau.pdf",
            letter = null,
            status = ApplyJobStatus.REJECTED,
            createdAt = "2026-03-24T10:00:00",
            updatedAt = "2026-03-29T16:00:00"
        )
    )

    // Toutes les candidatures
    val allApplications = pendingApplications + acceptedApplications + rejectedApplications

    // Fonctions utilitaires pour filtrer
    fun getApplicationsByJob(jobId: String): List<ApplyJob> {
        return allApplications.filter { it.job == jobId }
    }

    fun getApplicationsByUser(userId: String): List<ApplyJob> {
        return allApplications.filter { it.user == userId }
    }

    fun getApplicationsByStatus(status: ApplyJobStatus): List<ApplyJob> {
        return allApplications.filter { it.status == status }
    }
}